import { Container, Row, Col } from "react-bootstrap";
import Image from 'react-bootstrap/Image';

function Design() {
    return (
        <Container fluid>
            <Row>
                <Col style={{ marginTop: '10px' }} md={3}>
                    <Image
                        src="https://firebasestorage.googleapis.com/v0/b/p-a-plans.appspot.com/o/projects%2F14big.jpg?alt=media"
                        style={{ width: '300px', height: '200px' }}
                        rounded
                        fluid />
                </Col>
                <Col style={{ marginTop: '10px' }} md={3}>
                    <Image
                        src="https://firebasestorage.googleapis.com/v0/b/p-a-plans.appspot.com/o/projects%2F10big.jpg?alt=media"
                        style={{ width: '300px', height: '200px' }}
                        rounded
                        fluid />
                </Col>
                <Col style={{ marginTop: '10px' }} md={3}>
                    <Image
                        src="https://firebasestorage.googleapis.com/v0/b/p-a-plans.appspot.com/o/projects%2F12big.jpg?alt=media"
                        style={{ width: '300px', height: '200px' }}
                        rounded
                        fluid />
                </Col>
                <Col style={{ marginTop: '10px' }} md={3}>
                    <Image
                        src="https://firebasestorage.googleapis.com/v0/b/p-a-plans.appspot.com/o/projects%2F11big.jpg?alt=media"
                        style={{ width: '300px', height: '200px' }}
                        rounded
                        fluid />
                </Col>
                <Col style={{ marginTop: '10px' }} md={3}>
                    <Image
                        src="https://firebasestorage.googleapis.com/v0/b/p-a-plans.appspot.com/o/projects%2F10big.jpg?alt=media"
                        style={{ width: '300px', height: '200px' }}
                        rounded
                        fluid />
                </Col>
                <Col style={{ marginTop: '10px' }} md={3}>
                    <Image
                        src="https://firebasestorage.googleapis.com/v0/b/p-a-plans.appspot.com/o/projects%2F9big.jpg?alt=media"
                        style={{ width: '300px', height: '200px' }}
                        rounded
                        fluid />
                </Col>
                <Col style={{ marginTop: '10px' }} md={3}>
                    <Image
                        src="https://firebasestorage.googleapis.com/v0/b/p-a-plans.appspot.com/o/projects%2F15big.jpg?alt=media"
                        style={{ width: '300px', height: '200px' }}
                        rounded
                        fluid />
                </Col>
                <Col style={{ marginTop: '10px' }} md={3}>
                    <Image
                        src="https://firebasestorage.googleapis.com/v0/b/p-a-plans.appspot.com/o/projects%2F14big.jpg?alt=media"
                        style={{ width: '300px', height: '200px' }}
                        rounded
                        fluid />
                </Col>
            </Row>
        </Container>
    );
};
export default Design;